module.exports = __webpack_public_path__ + "static/media/b_knight.c873beb3.png";